import { render, staticRenderFns } from "./land-promo.vue?vue&type=template&id=d64ced30"
import script from "./land-promo.vue?vue&type=script&lang=js"
export * from "./land-promo.vue?vue&type=script&lang=js"
import style0 from "./land-promo.vue?vue&type=style&index=0&id=d64ced30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports